export const os = navigator.platform;

export const android = /(android)/i.test(navigator.userAgent);
export const chrome = !!window.chrome;
export const firefox = typeof InstallTrigger !== 'undefined';
export const ie = /* @cc_on!@ */ false || document.documentMode;
export const edge = !ie && !!window.StyleMedia;
export const ios = !!navigator.userAgent.match(/(iPod|iPhone|iPad)/i);
// eslint-disable-next-line
export const safari =
	Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') >
		0 ||
	(!chrome && window.webkitAudioContext !== 'undefined');
